/* jshint node:true */
'use strict';
var React = require('react');
var Router = require('react-router');
var Game = require('../rugby/game/index.jsx');
var StoreMixin = require('fluxible/addons/FluxibleMixin');
var ESPNhelpersMixin = require('../../mixins/ESPNhelpersMixin');
var loadScores = require('../../actions/loadScores');
var TabLinks = require('../rugby/game/TabLinks.jsx');
var GameFooter = require('../scoreboard/game-strip/GameFooter.jsx');
var GameStrip = require('../scoreboard/game-strip/GameStrip.jsx');
var Advert = require('../common/Advert.jsx');
var AdReloaderMixin = require('../../mixins/AdReloaderMixin.js');
var pollInterval = 30000;
var hValidView = {
    summary:1,
    report:1,
    preview:1,
    commentary:1,
    matchstats:1,
    playerstats:1,
    lineups:1,
    table:1,
    conversation:1
};

var Gamecast = React.createClass({

    displayName: 'Gamecast',

    mixins: [
        Router.State, StoreMixin, ESPNhelpersMixin, AdReloaderMixin, Router.Navigation, Router.IsActive
    ],

    statics: {
        loadAction: loadScores,
        storeListeners: ['ScoreStore']
    },

    getInitialState: function () {
        return this.getStateFromStores();
    },

    timer: null,

    poll: function(){
        var self = this;
        var isActiveGamecastRoute = this.isActive('match', this.getParams(), this.getQuery());
        var isGamepackage = /\/rugby\/match|commentary|lineups|matchstats|playerstats|conversation/.test(location.pathname);
        // Is it the home route that points to the gamecast handler for local testing?
        var isFudgedHomeRoute = this.isActive('home', this.getParams(), this.getQuery()) && /local/.test(location.host);
        if((isActiveGamecastRoute && isGamepackage) || isFudgedHomeRoute){
            self.props.context.executeAction(loadScores, {
                pathname : self.getPathname(),
                query : self.getQuery()
            });
        }else {
            clearInterval(self.timer);
            self.timer = null;
        }
    },

    componentWillMount: function() {
        this.timer = setInterval(this.poll, pollInterval);
    },

    componentWillUpdate: function(prevProps, prevState) {
        try {
            if(this.props.params.section != prevProps.params.section){
                var bannerAd = this.getAd('banner');
                if(bannerAd !== null){
                    admgr.refresh([bannerAd]);
                }
            }
        }catch(e){}
    },

    getAd: function(type){
        try {
            var arr = admgr.getGPTArray();
            for (var i=0,len = arr.length; i < len; i++ ){
                if(arr[i].type === type){
                    return arr[i];
                }
            }
        }catch(e){}
        return null;
    },

    getStateFromStores: function () {
        var store = this.props.context.getStore('ScoreStore');
        var gameStripProps = store.getGameStripDetails();
        var section = this.getParams().section;

        this.setMetaData(gameStripProps, section);
        var aStandings = store.getLeagueTable();
        var bHasStandings = false;
        if(aStandings.length >= 1){
            bHasStandings = true;
        }

        return {
            gameStripProps : gameStripProps,
            matchState : store.getMatchState(),
            matchView: this.state && this.state.matchView || section || 'summary',
            tableLink: store.getTableLink(),
            hasCommentary: store.hasCommentary(),
            hasStandings: bHasStandings,
            hasStats: store.hasStats(),
            hasReport: store.hasReport(),
            hasPreview: store.hasPreview(),
            adWrapSelector : '#game-banner'
        };
    },

    setMetaData: function(gameStripProps, section){
        try {
            this._meta.activeTab = this.state && this.state.matchView || section || 'summary';
            this._meta.home = gameStripProps.teams.home.name;
            this._meta.away = gameStripProps.teams.away.name;
            this._meta.date = gameStripProps.date;
            this._meta.league = gameStripProps.heading;
        }catch(e){}
    },

    onChange: function () {
        this.setState(this.getStateFromStores());
    },

    changeView: function(sView){
        var query = this.getQuery();
        if(hValidView[sView] === 1){
            this.setState({matchView:sView});
        }
        this.transitionTo('/rugby/' + (sView === 'summary' ? 'match' : sView), {}, query);
    },

    render: function () {

        if(this.state.matchState == 'post'){
            clearInterval(this.timer);
        }

        var gameStripProps = this.state.gameStripProps;
        var query = this.getQuery() || {};
        var classMap = {
            'pregame' : 'pre',
            'live' : 'live',
            'final' : 'post'
        };

        return (
            <div style={this.props.shell ? {} : {marginTop:'190px'}} data-pagetype="gamepackage">
                <div id="custom-nav">
                    <GameStrip {...gameStripProps} />
                    <GameFooter
                        styles={{marginBottom:'1px', borderBottom:'none'}}
                        classNames={'game-details footer rugby'}
                        summary={gameStripProps.gameDetails}
                        text={gameStripProps.footer}
                        gameStatus={classMap[gameStripProps.gameStatus]}
                        sport="rugby"
                    />
                    <div id="gamepackage-links-wrap">
                        <TabLinks
                            tableHref={this.state.tableLink}
                            selected={this.state.matchView}
                            matchState={this.state.matchState}
                            changeView={this.changeView}
                            commentaryLink={this.state.hasCommentary}
                            standingsLink={this.state.hasStandings}
                            statsLink={this.state.hasStats}
                            reportLink={this.state.hasReport}
                            previewLink={this.state.hasPreview}
                        />
                    </div>
                </div>
                <Advert id='game-banner' className="ad-slot ad-slot-banner ad-wrapper"  slotType="banner" data-slot-kvps="pos=banner" />
                <section id="main-container">
                    <Game query={query} tableHref={this.state.tableLink} matchView={this.state.matchView} changeView={this.changeView} context={this.props.context} gameProps={this.state} matchState={this.state.matchState}/>
                </section>
            </div>
        );
    }

});

module.exports = Gamecast;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/handlers/Gamecast.jsx
 **/